module.exports = __webpack_public_path__ + "static/communication-6299e3a548054338f236bdad85dbadf3.jpg";